function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { salesmanDataListApi, performanceStatisticsApi, contracRankApi, trendStatisticsApi } from '@/api/enterprise';
import { numberFormat } from '@/utils/numberFormat';
export default {
  name: 'Turnover',
  components: {
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    // formBox: () => import('./components/formBox'),
    echartBox: function echartBox() {
      return import('@/components/common/echarts');
    }
  },
  data: function data() {
    return {
      optionData: {},
      optionData1: {},
      pieChartData: {},
      income: {},
      renew: {},
      active: '合同分类',
      breadcrumbList: [{
        name: '合同分类',
        id: ''
      }],
      category_id: '',
      contract_rank: [],
      frame_rank: [],
      new_customer: {},
      new_contract: {},
      new_contract_price: {},
      uncollected_price: {},
      styles1: {
        height: '300px',
        width: '100%',
        margin: 'auto'
      },
      tableData: [],
      where: {
        page: 1,
        limit: 15,
        scope_frame: 'all',
        time: this.$moment().subtract(1, 'months').format('YYYY/MM/DD') + '-' + this.$moment().format('YYYY/MM/DD')
      },
      activeId: '',
      total: 0,
      search: [{
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time',
        form_value: 'date_picker',
        data_dict: [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')]
      }, {
        field_name: '管理范围',
        field_name_en: 'scope_frame',
        form_value: 'manage'
      }, {
        field_name: '合同分类',
        field_name_en: 'category_id',
        form_value: 'cascader',
        data_dict: []
      }],
      timeVal: [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')],
      time: ''
    };
  },
  filters: {
    absNum: function absNum(a) {
      if (a < 0) {
        a = a * -1;
      }
      return a;
    }
  },
  mounted: function mounted() {
    this.where.time = "".concat(this.timeVal[0], "-").concat(this.timeVal[1]);
    this.contractList();
    this.getChartList();
    this.trendStatistics();
    this.getTableData();
    this.getActive();
  },
  methods: {
    // 获取合同分类列表
    contractList: function contractList() {
      var _this = this;
      var data = {
        level: '',
        types: 'contract_type'
      };
      this.$store.dispatch('user/getDictList', data).then(function (res) {
        setTimeout(function () {
          var resultDict = res.find(function (item) {
            return item.dict_ident == data.types;
          });
          if (resultDict.list) {
            // this.options = resultDict.list
            _this.search[2].data_dict = resultDict.list;
          }
        }, 300);
      });
    },
    format: function format(percentage) {
      if (percentage == 100) {
        return '完成';
      } else {
        return "".concat(percentage, "%");
      }
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.search[0].data_dict = this.timeVal;
        this.where = {
          time: this.timeVal[0] + '-' + this.timeVal[1],
          category_id: '',
          scope_frame: 'all'
        };
      } else {
        this.where = _objectSpread(_objectSpread({}, this.where), data);
      }
      this.breadcrumbList = [];
      this.getChartList(data.id);
      this.getTableData(data.id);
      var newName = {
        name: '合同分类',
        id: ''
      };
      this.activeId = '';
      this.breadcrumbList.push(newName);
      this.trendStatistics();
      this.getActive();
      this.contractList();
    },
    // 获取业绩趋势图数据
    trendStatistics: function trendStatistics() {
      var _this2 = this;
      // const data = {
      //   time: this.where.time,
      //   scope_frame: this.where.scope_frame,
      //   category_id: []
      // }
      // if (this.where.category_id)
      //   this.where.category_id.forEach((item, index) => {
      //     data.category_id[index] = '[' + item.join(',') + ']'
      //   })

      trendStatisticsApi(this.where).then(function (res) {
        _this2.xianchart(res.data);
      });
    },
    // 获取表格数据
    getTableData: function getTableData(id) {
      var _this3 = this;
      // const data = {
      //   time: this.where.time,
      //   scope_frame: this.where.scope_frame,
      //   category_id: []
      // }
      // if (this.where.category_id)
      //   this.where.category_id.forEach((item, index) => {
      //     data.category_id[index] = '[' + item.join(',') + ']'
      //   })
      salesmanDataListApi(this.where).then(function (res) {
        _this3.tableData = res.data.list.map(function (item) {
          item.price = numberFormat(Number(item.price));
          return item;
        });
        function compare(property) {
          return function (a, b) {
            var value1 = a[property];
            var value2 = b[property];
            return value2 - value1;
          };
        }
        _this3.tableData.sort(compare('ratio'));
        _this3.total = res.data.count;
      });
    },
    getChartList: function getChartList(id) {
      var _this4 = this;
      // const data = {
      //   time: this.where.time,
      //   scope_frame: this.where.scope_frame,
      //   category_id: []
      // }
      // if (this.where.category_id)
      //   this.where.category_id.forEach((item, index) => {
      //     data.category_id[index] = '[' + item.join(',') + ']'
      //   })
      performanceStatisticsApi(this.where).then(function (res) {
        var data = res.data;
        _this4.income = data.income;
        _this4.income.price = numberFormat(data.income.price);
        _this4.renew = data.renew;
        _this4.renew.price = numberFormat(data.renew.price);
        _this4.new_customer = data.new_customer;
        _this4.new_contract = data.new_contract;
        _this4.new_contract_price = data.new_contract_price;
        _this4.new_contract_price.price = numberFormat(data.new_contract_price.price);
        _this4.uncollected_price = data.uncollected_price;
        _this4.uncollected_price.price = numberFormat(data.uncollected_price.price);
        _this4.frame_rank = res.data.frame_rank;
        _this4.optionData = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#CCCCCC'
              }
            }
          },
          legend: {
            data: [],
            show: true,
            right: 10,
            top: 0
          },
          grid: {
            left: 60,
            top: 40,
            right: 20,
            bottom: 40
          },
          toolbox: {},
          color: ['#1890FF'],
          xAxis: [{
            type: 'category',
            nameTextStyle: {
              color: '#CCCCCC'
            },
            axisLine: {
              lineStyle: {
                color: '#CCCCCC'
              }
            },
            axisLabel: {
              color: '#666666'
            },
            data: []
          }],
          yAxis: [{
            type: 'value',
            position: 'left',
            axisTick: {
              show: true,
              alignWithLabel: true
            },
            min: 0,
            nameTextStyle: {
              color: '#CCCCCC'
            },
            axisLine: {
              lineStyle: {
                color: '#CCCCCC'
              }
            },
            axisLabel: {
              color: '#666666'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }],
          series: [{
            name: '',
            type: 'bar',
            smooth: true,
            barWidth: 25,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  color: '#fff',
                  fontSize: 14,
                  lineHeight: 20,
                  backgroundColor: '#666',
                  padding: [3, 5, 3, 5],
                  borderRadius: 5,
                  position: 'top',
                  formatter: '{c}'
                }
              }
            },
            data: []
          }]
        };
        if (data.frame_rank.length > 0) {
          _this4.optionData.series[0].data = data.frame_rank.map(function (item) {
            return item.price;
          });
          _this4.optionData.xAxis[0].data = data.frame_rank.map(function (item) {
            return item.name;
          });
        }
      });
    },
    // 趋势图
    xianchart: function xianchart(data) {
      var _this5 = this;
      // 趋势图
      this.optionData1 = {
        color: ['#19BE6B', '#FF9900'],
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(option) {
            return "".concat(_this5.$moment(option[0].axisValue).format('YYYY年MM月DD日'), "<br/>").concat(option[0].seriesName, "\uFF1A").concat(option[0].value, "\u5143<br/>").concat(option[1].seriesName, "\uFF1A").concat(option[1].value, "\u5143");
          }
        },
        grid: {
          left: 0,
          top: 40,
          right: 20,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          nameTextStyle: {
            color: '#86909C'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#C9CDD4'
            }
          },
          axisLabel: {
            color: '#666666'
          },
          data: data.xAxis
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#86909C'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [{
          name: '流入',
          type: 'line',
          itemStyle: {
            normal: {
              color: '#19BE6B'
            }
          },
          smooth: true,
          data: data.series[0].data
        }, {
          name: '流出',
          type: 'line',
          itemStyle: {
            normal: {
              color: '#FF9900'
            }
          },
          smooth: true,
          data: data.series[1].data
        }, {
          name: this.$t('finance.totalexpenditure'),
          type: 'line',
          symbol: 'circle',
          // symbolSize: 5, // 圆点大小
          smooth: true,
          lineStyle: {
            width: 1,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            shadowBlur: 10,
            color: '#19BE6B'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#19BE6B' // 0% 处的颜色
              }, {
                offset: 0.9,
                color: '#fff' // 100% 处的颜色
              }],
              global: false
            }
          },
          data: data.series[0].data
        }, {
          name: this.$t('finance.totalexpenditure'),
          type: 'line',
          symbol: 'circle',
          // symbolSize: 5, // 圆点大小
          smooth: true,
          lineStyle: {
            width: 1,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            shadowBlur: 10,
            color: '#FF9900'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#FF9900' // 0% 处的颜色
              }, {
                offset: 0.9,
                color: '#FFF' // 100% 处的颜色
              }],
              global: false
            }
          },
          data: data.series[1].data
        }]
      };
    },
    // 处理圆环显示数据
    deconstruction: function deconstruction(data) {
      var boxData = [];
      var totalData = '';
      this.contract_rank.map(function (item) {
        var itemData = {
          value: item.price,
          name: item.category_name,
          id: item.category_id
        };
        boxData.push(itemData);
      });
      totalData = this.contract_rank.reduce(function (totalData, obj) {
        return totalData += Number(obj.price);
      }, 0);
      totalData = numberFormat(parseFloat(totalData).toFixed(2));
      this.pieChartData = {
        color: ['tomato', 'deepskyblue', 'orange', 'mediumseagreen', 'violet', 'dodgerblue', 'khaki', 'turquoise', 'salmon', 'darkslategray'],
        // 鼠标移动展示
        tooltip: {
          trigger: 'item',
          enterable: true,
          formatter: function formatter(option) {
            return "".concat(option.seriesName, " <br/> ").concat(option.name, "(").concat(data[option.dataIndex].count, "): ").concat(option.value, "\u5143\n            ").concat(option.percent, "%");
          }
        },
        // 分类
        legend: [{
          type: 'scroll',
          orient: 'vertical',
          right: '0%',
          // 距离右侧位置
          itemGap: 18,
          itemHeight: 16,
          // 图标大小设置
          icon: 'circle',
          data: '',
          y: 'center',
          pageIconSize: 12,
          textStyle: {
            fontSize: 12,
            color: '#333',
            lineHeight: 20,
            // 解决提示语字显示不全
            rich: {
              a: {
                padding: [0, 10, 0, 10],
                color: '#FF0000'
              },
              b: {
                color: '#666'
              },
              c: {
                color: '#ff9900'
              }
            }
          },
          formatter: function formatter(name) {
            var target;
            var ratio;
            var count;
            var expend;
            var total = 0;
            // 首先计算总数
            data.forEach(function (item) {
              total += Number(item.price);
            });

            // 然后找到每个项目，并计算其百分比
            for (var i = 0; i < data.length; i++) {
              if (data[i].category_name === name) {
                target = numberFormat(data[i].price);
                ratio = (Number(data[i].price) / total * 100).toFixed(2); // 计算百分比
                count = data[i].count;
                expend = data[i].expend;
                if (data[i].expend != 0) {
                  expend = '-' + data[i].expend;
                }
              }
            }
            var arr = ["".concat(name, "(").concat(count, "){a|").concat(target, "\u5143}{c|").concat(expend, "\u5143} {b|").concat(ratio, "%}")];
            return arr.join('\n');
          }
        }],
        series: [{
          type: 'pie',
          data: boxData,
          label: {
            show: true,
            position: 'center',
            formatter: [totalData, '{name|总计合同金额(元)}'].join('\n'),
            color: '#333',
            textStyle: {
              fontSize: 18,
              fill: '#333',
              lineHeight: 26,
              rich: {
                name: {
                  fontSize: 12,
                  color: '#3D3D3D'
                }
              }
            }
          },
          right: '40%',
          name: this.$t("customer.contracttype"),
          radius: ['55%', '70%'],
          center: ['40%', '50%']
        }]
      };
    },
    indexAdd: function indexAdd(index) {
      var page = this.where.page; // 当前页码
      var pagesize = this.where.limit; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
    customColorMethod: function customColorMethod(row) {
      return 'rgb(' + (255 - row.ratio * 12) + ',' + (255 - row.ratio * 12) + ',255)';
    },
    getActive: function getActive() {
      var _this6 = this;
      var data = {
        time: this.where.time,
        scope_frame: this.where.scope_frame,
        category_id: []
      };
      // if (this.where.category_id)
      //   this.where.category_id.forEach((item, index) => {
      //     data.category_id[index] = '[' + item.join(',') + ']'
      //   })
      contracRankApi(data).then(function (res) {
        _this6.contract_rank = res.data;
        _this6.deconstruction(_this6.contract_rank);
      });
    },
    changeActive: function changeActive(row, index) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var item, result, _item, _result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this7.active = row.name;
              _this7.activeId = row.id;
              _this7.breadcrumbList.splice(index + 1);
              if (!(row.name == '合同分类')) {
                _context.next = 14;
                break;
              }
              item = {
                time: _this7.where.time,
                scope_frame: _this7.where.scope_frame,
                category_id: []
              };
              if (_this7.where.category_id) _this7.where.category_id.forEach(function (item, index) {
                item.category_id[index] = '[' + item.join(',') + ']';
              });
              _context.next = 8;
              return contracRankApi(item);
            case 8:
              result = _context.sent;
              _this7.contract_rank = result.data;
              _this7.deconstruction(result.data);
              _this7.breadcrumbList = [{
                name: '合同分类',
                id: ''
              }];
              _context.next = 21;
              break;
            case 14:
              _item = {
                time: _this7.where.time,
                scope_frame: _this7.where.scope_frame,
                category_id: [],
                category: row.id
              };
              if (_this7.where.category_id) _this7.where.category_id.forEach(function (item, index) {
                item.category_id[index] = '[' + item.join(',') + ']';
              });
              _context.next = 18;
              return contracRankApi(_item);
            case 18:
              _result = _context.sent;
              _this7.contract_rank = _result.data;
              _this7.deconstruction(_result.data);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 点击圆环图
    pieChange: function pieChange(row) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var item, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this8.active = row.name;
              if (!(_this8.activeId === row.id)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              _this8.activeId = row.id;
              item = {
                time: _this8.where.time,
                scope_frame: _this8.where.scope_frame,
                category_id: [],
                category: row.id
              };
              if (_this8.where.category_id) _this8.where.category_id.forEach(function (item, index) {
                item.category_id[index] = '[' + item.join(',') + ']';
              });
              _context2.next = 10;
              return contracRankApi(item);
            case 10:
              result = _context2.sent;
              _this8.contract_rank = result.data;
              _this8.deconstruction(result.data);
              _this8.breadcrumbList.push(row);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};